export enum UserLoyaltyTransactionType {
  FIRST_ORDER = "FIRST_ORDER",
  ITEM_ORDER = "ITEM_ORDER",
  REGISTRATION = "REGISTRATION",
  ONE_PERCENT_ORDER = "ONE_PERCENT_ORDER",
  DELIVERY_PAYMENT = "DELIVERY_PAYMENT",
  DELIVERY_PROFIT = "DELIVERY_PROFIT",
  LOYALTY_POINTS_PURCHASE = "LOYALTY_POINTS_PURCHASE",
  ITEM_PAYMENT = "ITEM_PAYMENT",
  ITEM_COMMENT = "ITEM_COMMENT",
}

export interface UserResponse {
  id: number;
  firstName: string;
  secondName: string;
  email: string;
  phoneNumber: string;
}

export interface UserLoyaltyTransactionResponse {
  id: number;
  name: string;
  loyaltyPoints: number;
  type: UserLoyaltyTransactionType;
  userResponse: UserResponse | null;
  orderNumber: number | null;
  created: string; // ISO date string
}

export interface LoyaltyTransactionFilters {
  createdFrom: Date;
  createdTo: Date;
  userId?: number;
  page: number;
  numOfReturns: number;
}

// Human-readable labels for transaction types
export const LOYALTY_TRANSACTION_TYPE_LABELS: Record<
  UserLoyaltyTransactionType,
  string
> = {
  [UserLoyaltyTransactionType.REGISTRATION]: "Registracija",
  [UserLoyaltyTransactionType.FIRST_ORDER]: "Prva rezervacija",
  [UserLoyaltyTransactionType.ITEM_ORDER]: "Loyalty proizvod",
  [UserLoyaltyTransactionType.ONE_PERCENT_ORDER]: "1% vrednosti rezervacije",
  [UserLoyaltyTransactionType.DELIVERY_PAYMENT]: "Dostava",
  [UserLoyaltyTransactionType.DELIVERY_PROFIT]: "Dostava",
  [UserLoyaltyTransactionType.LOYALTY_POINTS_PURCHASE]: "Kupovina poena",
  [UserLoyaltyTransactionType.ITEM_PAYMENT]: "Loyalty transakcija",
  [UserLoyaltyTransactionType.ITEM_COMMENT]: "Ocena i komentar",
};
